import { Typography } from 'src/shared/core/ui';

import { Loader } from '../index';

const LoadingSection = ({
  color = 'var(--primary)',
  message = '',
  bg = 'black',
  scale = 3,
  positionCenter = true,
}: {
  color?: string;
  message?: string;
  bg?: string;
  scale?: number;
  positionCenter?: boolean;
}) => {
  return (
    <div
      className={` ${positionCenter ? 'inset-0' : ''} bg-transparent w-full h-full  space-y-3 p-2 flex-col flex justify-center items-center animated fadeIn duration-200`}
    >
      <Loader color={color} scale={scale} />
      {message && (
        <Typography key={'loading-message'} variant={'heading2'} weight={600}>
          {message}
        </Typography>
      )}
    </div>
  );
};

export default LoadingSection;
